import { calculatePercentageFromTotal } from ".";
import { ProgressBarItem } from "../components/multistatusprogressbar/multistatusprogressbar.types";

export function getProfilingInfo(
  totalCount: number,
  distinctCount: number,
  blankCount: number,
  emptyStringCount?: number,
  colNullCnt?: number
): ProgressBarItem[] {
  return [
    {
      type: "error",
      value: calculatePercentageFromTotal(
        blankCount || 0,
        (distinctCount || 0) + (totalCount || 0)
      ),
      valueDetail: `${blankCount || 0}`,
    },
    emptyStringCount !== undefined && {
      type: "info_empty",
      value: calculatePercentageFromTotal(
        emptyStringCount || 0,
        (distinctCount || 0) + (totalCount || 0)
      ),
      valueDetail: `${emptyStringCount || 0}`,
    },
    colNullCnt !== undefined && {
      type: "info_null",
      value: calculatePercentageFromTotal(
        colNullCnt || 0,
        (distinctCount || 0) + (totalCount || 0)
      ),
      valueDetail: `${colNullCnt || 0}`,
    },
    {
      type: "warning",
      value: calculatePercentageFromTotal(
        distinctCount || 0,
        (distinctCount || 0) + (totalCount || 0)
      ),
      valueDetail: `${distinctCount || 0}`,
    },
    {
      type: "success",
      value: calculatePercentageFromTotal(
        (totalCount || 0) - (blankCount || 0),
        (distinctCount || 0) + (totalCount || 0)
      ),
      valueDetail: `${(totalCount || 0) - (blankCount || 0)}`,
    },
  ].filter(Boolean) as ProgressBarItem[];
}
